module.exports = __webpack_public_path__ + "img/5.9b345a33.png";